import { Star, Quote, BadgeCheck } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { reviews } from "./data";

const Stars = ({ size = "w-4 h-4" }) => (
  <div className="flex gap-1" aria-label="5 out of 5 stars">
    {[...Array(5)].map((_, s) => (
      <Star key={s} className={`${size} text-amber-500`} fill="currentColor" />
    ))}
  </div>
);

const Reviews = () => (
  <section data-testid="reviews-section" className="bg-[#FAFAFA] py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <Reveal className="mb-14 md:mb-16 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10">
        <div className="max-w-xl">
          <Overline>Kind words</Overline>
          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900">
            Rated five stars by local customers
          </h2>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-slate-600">
            Homeowners and landlords across Basildon and Essex keep coming back
            — and recommend us to their neighbours.
          </p>
        </div>
        <div
          data-testid="reviews-summary"
          className="flex items-center gap-6 bg-white border border-slate-200 rounded-md px-8 py-6 shrink-0"
        >
          <span className="font-heading text-6xl md:text-7xl font-bold leading-none text-slate-900">
            5.0
          </span>
          <div>
            <Stars size="w-5 h-5" />
            <p className="mt-2 text-sm font-semibold text-slate-600">
              Average rating
              <span className="block text-xs font-medium text-slate-500 mt-0.5">
                from recent customer reviews
              </span>
            </p>
          </div>
        </div>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.map((r, i) => (
          <Reveal
            key={r.name}
            delay={(i % 3) * 0.08}
            className="bg-white border border-slate-200 rounded-md p-8 flex flex-col"
          >
            <div className="flex items-center justify-between">
              <Quote className="w-6 h-6 text-slate-200" fill="currentColor" />
              <Stars />
            </div>
            <p
              data-testid={`review-quote-${i}`}
              className="mt-5 text-base leading-relaxed text-slate-700 flex-1"
            >
              &ldquo;{r.quote}&rdquo;
            </p>
            <div className="mt-6 pt-5 border-t border-slate-100 flex items-center gap-2.5">
              <p className="text-sm font-bold text-slate-900">
                {r.name}
                <span className="ml-2 font-semibold text-slate-500">{r.area}</span>
              </p>
              <BadgeCheck
                className="w-4 h-4 text-blue-600 ml-auto"
                aria-label="Verified customer"
              />
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Reviews;
